import { useState } from 'react'
import cn from 'classnames'
import s from './SwitchToggle.scss'

const SwitchToggle = ({
  className,
  children,
  noText,
  id,
  large = false,
  theme = 'success',
  onToggle,
  defaultOn,
  isDisabled
}) => {
  const [checked, setChecked] = useState(defaultOn)

  if (defaultOn !== checked) setChecked(defaultOn)

  return (
    <div className={className}>
      <div
        aria-label={children}
        className={cn(s.switch, {
          [s.large]: large,
          [s.noText]: noText,
          [s.success]: theme === 'success'
        })}
      >
        <label className={s.label} htmlFor={id || children.replace(/\s/g, '')}>
          <input
            checked={defaultOn ?? checked}
            defaultChecked={defaultOn ?? false}
            role="switch"
            type="checkbox"
            className={s.input}
            id={id || children.replace(/\s/g, '')}
            onClick={value => {
              if (isDisabled) {
                value.preventDefault()
                return
              }
              onToggle(value.target.checked)
            }}
          />
          <span className={s.text} data-on="ON" data-off="OFF"></span>
          <span className={s.handle}></span>
        </label>
      </div>
      <span className={s.children}>{children}</span>
    </div>
  )
}

export default SwitchToggle
